export * from './lib/stock-view';
